import { render, staticRenderFns } from "./configurable-material-specsheet.vue?vue&type=template&id=a4c428aa&scoped=true"
import script from "./configurable-material-specsheet.vue?vue&type=script&lang=ts"
export * from "./configurable-material-specsheet.vue?vue&type=script&lang=ts"
import style0 from "./configurable-material-specsheet.vue?vue&type=style&index=0&id=a4c428aa&prod&scoped=true&lang=css"
import style1 from "./configurable-material-specsheet.vue?vue&type=style&index=1&id=a4c428aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c428aa",
  null
  
)

export default component.exports